export const discoverKeys = {
  all: ["discover"] as const,
  requestContext: () => [...discoverKeys.all, "request-context"] as const,
  potentialBuddies: (rankingSeed = "initial") =>
    [...discoverKeys.all, "potential-buddies", rankingSeed] as const,
};
